export interface FetchErrorInput {
  trace: string;
  message: string;
  details?: unknown;
}

export default class FetchError extends Error {
  constructor(error: unknown);

  constructor(error: string);

  constructor(error?: FetchErrorInput | string) {
    console.error(error);
    super(typeof error === 'string' ? error : error?.message);
  }
}
